import type { ReactNode } from 'react'
import { EmptyState, IllustrationEmpty } from '@rentflowdev/ui'

interface PropertiesEmptyStateProps {
	title: string
	description: string
	onAdd?: () => void
	/** Custom action — when provided, replaces the default "Добавить объект" button. */
	actionSlot?: ReactNode
}

export function PropertiesEmptyState({ title, description, onAdd, actionSlot }: PropertiesEmptyStateProps) {
	return (
		<EmptyState
			illustration={<IllustrationEmpty />}
			title={title}
			description={description}
			action={onAdd ? { label: 'Добавить объект', onClick: onAdd } : undefined}
			actionSlot={actionSlot}
		/>
	)
}
